import React from 'react';
import { useTranslation } from 'react-i18next';
import { Controller, UseFormReturn } from 'react-hook-form';
import { Col, FormFeedback, Input, Label, Row } from 'reactstrap';

type MedicalFormPartCPropsTypes = {
  form: UseFormReturn<any, object>;
};

export const MedicalFormPartC = (props: MedicalFormPartCPropsTypes) => {
  const { t } = useTranslation();

  const {
    control,
    getValues,
    formState: { errors },
  } = props.form;

  return (
    <div>
      <Row className="section-title">
        <Col md="6">
          <div>{t('MEDICAL_DECLARATION_PART_C_TITLE')}</div>
        </Col>
      </Row>
      <Row>
        <Col md="12">
          <div className="medical-declaration-paragraph-explain">
            {t('MEDICAL_DECLARATION_PART_C_FIRST_EXPLAIN')}
          </div>
        </Col>
        <Col md="12">
          <div className="medical-declaration-paragraph">
            {t('MEDICAL_DECLARATION_PART_C_SECOND_EXPLAIN')}
          </div>
        </Col>
      </Row>
    </div>
  );
};
